import React from "react";
import { forwardRef } from "react";
import "../styles/Mentors.css";


import Arvind_sir_pic from "../assets/faculty_img/Arvind_sir_pic.jpg"
import Pooja_maam_pic from "../assets/faculty_img/Pooja_maam_pic.jpg"
import Dinesh_ubuy_pic from "../assets/faculty_img/Dinesh_sir_ubuy.JPG"
import Vivek_provis_pic from "../assets/faculty_img/Vivek_sharma_provis.png"

import Pramod_Kumar_Gupta_pic from "../assets/faculty_img/Pramod_Kumar_Gupta.png"
import Dhirendra_Malhotra_pic from "../assets/faculty_img/Dhirendra_Malhotra.png"


import Judge1_pic from "../assets/faculty_img/judge3_pic.jpg"
import Judge2_pic from "../assets/faculty_img/judge4_pic.jpg"
import Judge3_pic from "../assets/faculty_img/judge5_pic.jpg"
import Judge4_pic from "../assets/faculty_img/judge6_pic.jpg"
import Judge5_pic from "../assets/faculty_img/Ankit_sir_pic.jpg"

import Reveal_pic from "../assets/image.png"

const Judges = forwardRef((props, ref) => {
  const chief_guests = [
    { name: "Dr. Arvind Agarwal", expertise: "President, Arya Group of Colleges", pic: Arvind_sir_pic },
    { name: "Dr. Pooja Agarwal", expertise: "Vice President, Arya Group of Colleges", pic: Pooja_maam_pic },
    { name: "DINESH KUMAR", expertise: "Director @ Ubuy Technologies Private Limited, Jaipur", pic: Dinesh_ubuy_pic },
    { name: "Vivek Sharma", expertise: "Co-founder, Creative & Technical Director @ Provis Technologies, Jaipur", pic: Vivek_provis_pic },
  ];

  const spl_guests = [
    { name: "Pramod Kumar Gupta", expertise: "L & D Manager @ TechproCompSoft Pvt. Ltd., Noida", pic: Pramod_Kumar_Gupta_pic },
    { name: "Dhirendra Malhotra", expertise: "Lead O&B Excellence through Digitization in SCM", pic: Dhirendra_Malhotra_pic },
    { name: "", expertise: "", pic: Reveal_pic },
  ];

  
  const judges = [
    { name: "Dr. Ajay Saini", expertise: "Professor ACE", pic: Judge1_pic },
    { name: "Dr. Monika Lamba", expertise: "Professor ACE", pic: Judge2_pic },
    { name: "Mr. Pawan Sen", expertise: "Professor ACE", pic: Judge3_pic },
    { name: "Ms. Shilpi Mishra", expertise: "Professor ACE", pic: Judge4_pic },
    { name: "Dr. Ankit Taneja", expertise: "Professor ACE", pic: Judge5_pic }
  ];
  return (
    <section ref={ref} className="mentors-div">
      <h1>Our Special Guests</h1>
      <div className="judge-list">
        {spl_guests.map((spl_guests, index) => (
          <div key={index} className="judge-card">
            <img src={spl_guests.pic}></img>
            <h3>{spl_guests.name}</h3>
            <p>{spl_guests.expertise}</p>
          </div>
        ))}
      </div>


      <h1>Our Chief Guests</h1>
      <div className="judge-list">
        {chief_guests.map((chief_guests, index) => (
          <div key={index} className="judge-card">
            <img src={chief_guests.pic}></img>
            <h3>{chief_guests.name}</h3>
            <p>{chief_guests.expertise}</p>
          </div>
        ))}
      </div>
      
      <h1>Our Judges</h1>
      <div className="judge-list">
        {judges.map((judge, index) => (
          <div key={index} className="judge-card">
            <img src={judge.pic}></img>
            <h3>{judge.name}</h3>
            <p>{judge.expertise}</p>
          </div>
        ))}
      </div>
    </section>
  );
});

export default Judges;
